import { createContext, useContext } from 'react';

const ParametersContext = createContext<LocalParameters | undefined>(undefined);

export const useParameters = (): LocalParameters => {
  const context = useContext(ParametersContext);
  if (!context) {
    throw new Error('useParameters must be used within a ParametersProvider');
  }
  return context;
};

export default ParametersContext;

